import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const StructuredData = () => {
  const { t, i18n } = useTranslation('seo');
  const currentLang = i18n.language;

  // VideoGame schema (more specific than WebApplication)
  const gameSchema = {
    "@context": "https://schema.org",
    "@type": "VideoGame",
    "name": t('structuredData.name'),
    "description": t('structuredData.description'),
    "url": "https://www.matcha-game.com",
    "image": "https://www.matcha-game.com/social-share.jpg",
    "genre": ["Memory Game", "Puzzle Game", "Card Matching Game", "Brain Training"],
    "keywords": currentLang === 'ko'
      ? "matcha 게임, 메모리 게임, 카드 맞추기, 데일리 챌린지"
      : "wordle alternative, daily memory challenge, aesthetic matching card game, minimalist game",
    "gamePlatform": ["Browser", "Web", "Desktop", "Mobile"],
    "playMode": "SinglePlayer",
    "applicationCategory": "Game",
    "operatingSystem": "Any (Web Browser)",
    "browserRequirements": "Requires JavaScript, HTML5",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "1250",
      "bestRating": "5"
    },
    "inLanguage": currentLang === 'ko' ? 'ko-KR' : 'en-US',
    "availableLanguage": ["en", "ko"],
    "featureList": t('structuredData.features', { returnObjects: true }),
    "author": {
      "@type": "Person",
      "name": "Savage",
      "url": "https://www.x.com/colored_savage"
    },
    "audience": {
      "@type": "PeopleAudience",
      "suggestedMinAge": "6"
    }
  };

  // FAQ schema (only for English, as we have FAQ data)
  const faqSchema = currentLang === 'en' ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": t('faq.questions', { returnObjects: true }).map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  } : null;

  return (
    <Helmet>
      {/* VideoGame schema */}
      <script type="application/ld+json">
        {JSON.stringify(gameSchema)}
      </script>

      {/* FAQ schema (English only) */}
      {faqSchema && (
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default StructuredData;
